import { FETCH_STAGE, FETCH_ONBOARDED } from './constants';

export const stageAction = {
  FETCH_STAGE,
  FETCH_ONBOARDED,
};
